module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-MediumOblique.070ecb4e.ttf";